import * as go from 'gojs';
import ContextMenu from '../../../../gojs/contextMenu/contextMenu';
import { store } from 'createStore';
import { setShowContextMenu } from 'store/contextmenu/reducer';
import type { TextAlignment } from 'store/units/types';
import type { FreeTextBoxNodeData } from '../../../../gojs/types';
const $ = go.GraphObject.make;

/**
 * Template for when a free textbox is added to canvas
 */

const showContextMenu = () => {
  store.dispatch(setShowContextMenu(true));
};

const hideContextMenu = () => {
  store.dispatch(setShowContextMenu(false));
};

const FreeTextBoxPanel = $(
  go.Node,
  {
    layerName: 'Background',
    resizable: true,
    reshapable: true,
    resizeObjectName: 'FREE_TEXT_BOX',
  },
  new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(
    go.Point.stringify,
  ),
  new go.Binding('width').makeTwoWay(),
  new go.Binding('height').makeTwoWay(),
  new go.Binding('zOrder'),
  new go.Binding('background', 'color', (color) => {
    return color;
  }),
  new go.Binding('isSelected', 'selected'),
  new go.Binding('contextMenu', '', (node, data) => {
    return ContextMenu(data.diagram, showContextMenu, hideContextMenu);
  }),
  $(
    go.Panel,
    'Auto',
    {
      name: 'BODY',
      stretch: go.GraphObject.Fill,
    },
    $(
      go.Shape,
      'Rectangle',
      {
        stroke: 'black',
        name: 'VIEW',
        stretch: go.GraphObject.Uniform,
        fill: null,
      },
      new go.Binding('strokeWidth', 'displayBorder', (displayBorder) => {
        if (displayBorder) {
          return 1;
        }
        return 0;
      }),
    ),
    $(
      go.TextBlock,
      {
        // textAlign: 'center',
        margin: new go.Margin(8, 8, 8, 8),
        editable: false,
        isMultiline: true,
        wrap: go.TextBlock.WrapFit,
      },
      new go.Binding(
        'alignment',
        'textAlignment',
        (textAlignment: TextAlignment) => {
          if (textAlignment === 'right') {
            return go.Spot.TopRight;
          } else if (textAlignment === 'left') {
            return go.Spot.TopLeft;
          } else {
            return go.Spot.Center;
          }
        },
      ),
      new go.Binding('text', 'message'),
      new go.Binding('font', '', (data: FreeTextBoxNodeData) => {
        const { textWeight, fontSize, font } = data;
        const weight = textWeight === 'bold' ? 700 : 400;
        return `normal normal ${weight} ${fontSize}px ${font}`;
      }),
      new go.Binding('stroke', 'textColor'),
    ),
  ),
);

export default FreeTextBoxPanel;
